import template from './ko-field-view-address.html';

class AddressComponentVM
{
	constructor(params)
	{
		this.params = params;
		this.value = ko_helper.safe_observable(params.value);
		this.extra_classes = ko_helper.safe_observableArray(params.extra_classes || []);

		// To handle JSON string arrays and [""] case
		this.display_value = ko.computed(() => {
			const val = this.value();
			if (typeof val === 'string')
			{
				try {
					const parsed = JSON.parse(val);
					if (Array.isArray(parsed))
					{
						if (parsed.length === 1 && parsed[0] === "")
							return null;

						return parsed[0] || null;
					}
				} catch (e) {
					return val;
				}
			}
			return val;
		});
	}
}


export default {
	name: 'ko-field-view-address',
	viewModel: AddressComponentVM,
	module_type: 'ko',
	template: template
}
